import React from 'react'

import { TopImageContent } from '..'
import { SectionProps } from '../../../../core/types/Help'
import { Text, List } from '../ContentItem'
import { HELP_IMAGES } from '../../../constants/HelpImages'
import { buildDynamicCopy } from '../../../../core/utils/Localization'

const Investments: React.FC<SectionProps> = ({ copy }) => {
  const copyContent = copy.investments

  const investmentSections = {
    overviewSection: (
      <TopImageContent
        altImage={copyContent.overview}
        content={
          <React.Fragment>
            <Text
              content={
                buildDynamicCopy(
                  copyContent.description_1,
                  <b>{copyContent.description_1_bold_1}</b>,
                  <b>{copyContent.description_1_bold_2}</b>,
                ) as React.ReactNode
              }
            />
            <Text content={copyContent.description_2} sx={{ mt: 12 }} />

            <Text
              content={
                buildDynamicCopy(
                  copyContent.list_1_description,
                  <b>{copyContent.list_1_description_bold}</b>,
                ) as React.ReactNode
              }
              sx={{ mt: 12 }}
            />
            <List
              items={[
                copyContent.list_1_item_1,
                copyContent.list_1_item_2,
                copyContent.list_1_item_3,
                copyContent.list_1_item_4,
                copyContent.list_1_item_5,
              ]}
            />

            <Text content={copyContent.description_3} sx={{ mt: 12 }} />

            <Text
              content={
                buildDynamicCopy(
                  copyContent.list_2_description,
                  <b>{copyContent.list_2_description_bold}</b>,
                ) as React.ReactNode
              }
              sx={{ mt: 12 }}
            />
            <List items={[copyContent.list_2_item_1, copyContent.list_2_item_2]} />
          </React.Fragment>
        }
        hasDivider={false}
        image={HELP_IMAGES.INVESTMENTS_WIDGET_DETAILS}
        imageLargeBreakPoint={10}
        sx={{ pt: 12 }}
      />
    ),
  }

  return investmentSections.overviewSection
}

export default Investments
